import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TopNav from "@/components/feature/TopNav";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import TickerBar from "./components/TickerBar";
import LiveFeed from "./components/LiveFeed";
import EveningHot from "./components/EveningHot";
import FreshGrid from "./components/FreshGrid";
import TopicsPreview from "./components/TopicsPreview";
import FaqSection from "./components/FaqSection";
import BrandSection from "./components/BrandSection";
import { useSeo } from "@/hooks/useSeo";
import { faqList } from "@/mocks/faq";
import { news } from "@/mocks/news";
import type { NewsItem } from "@/types/content";

const allNews = news as NewsItem[];

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "黑料网爆",
    alternateName: "黑料网爆 - 全网热点爆料聚合",
    description:
      "实时跟进今日最新爆料，晚间热搜、刚刚发生的新鲜事一站汇总，覆盖综艺、影视、音乐、品牌代言与网络热议。",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑料网爆",
    description: "面向中文互联网的娱乐热点资讯聚合站，按实时、晚间热搜与刚刚发生三个维度组织内容。",
    email: "hi@heiliaowangbao.example.com",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "实时爆料流",
    itemListElement: allNews.slice(0, 8).map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.title,
    })),
  },
];

export default function Home() {
  const location = useLocation();

  useSeo({
    title: "黑料网爆 | 全网热点爆料聚合 · 实时吃瓜雷达",
    description:
      "黑料网爆实时跟进今日最新爆料，晚间热搜、刚刚发生的新鲜事一站汇总。综艺、影视、音乐、品牌代言与网络热议话题持续更新，吃瓜网友蹲点必看。",
    keywords: "黑料网爆,黑料网爆实时,黑料网爆晚间热搜,黑料网爆今天,全网热点爆料,娱乐资讯聚合",
    canonicalPath: "/",
    jsonLd: homeJsonLd,
  });

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
  }, [location.hash]);

  return (
    <>
      <TopNav />
      <main>
        <Hero />
        <TickerBar />
        <LiveFeed />
        <EveningHot />
        <FreshGrid />
        <TopicsPreview />
        <FaqSection />
        <BrandSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}